import React, { useState, useEffect } from 'react';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      title: "Network Infrastructure",
      content: [
        "Physical security",
        "SD WAN - Managed, hybrid, and secure SD-WAN solutions",
        "Networking",
        "Wireless LAN (Wi-Fi) and network switching to cloud-managed security"
      ]
    },
    {
      title: "Data Center & Cloud Solutions",
      content: [
        "Data Centers colocation",
        "Fault-tolerant, high-availability SSAE 18 datacenter solutions",
        "Microsoft office 360",
        "Complete cloud platform managed by Microsoft-certified experts"
      ]
    },
    {
      title: "Security Services",
      content: [
        "Next-gen Firewall offers the first line of security defense",
        "Endpoint security, Keep servers and workstations healthy and secure",
        "Managed detection and response",
        "Protect firewalls and endpoints by our trusted security professionals"
      ]
    },
    {
      title: "Business Continuity & Consulting",
      content: [
        "Disaster recovery & backup solutions",
        "Security Awareness training and business security consulting",
        "Comprehensive business cybersecurity consulting service"
      ]
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.textContent = `
      @media (max-width: 768px) {
        .main-container { padding: 15px; }
        .main-title { 
          font-size: 28px !important;
          line-height: 32px !important;
          margin-bottom: 20px !important;
        }
        .flex-container {
          flex-direction: column !important;
          gap: 20px !important;
        }
        .image-container {
          flex: 1 !important;
          max-width: 100% !important;
          order: 2 !important;
        }
        .image {
          width: 100% !important;
          margin-left: 0 !important;
        }
        .faq-section {
          width: 100% !important;
          margin-left: 0 !important;
          order: 1 !important;
        }
        .question {
          padding: 14px 16px !important;
          font-size: 16px !important;
        }
        .answer-active {
          padding: 0 16px 14px !important;
        }
        .list-item {
          font-size: 13px !important;
          padding: 6px 0 !important;
        }
      }
    `;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  const styles = {
    mainContainer: {
      width: '100%',
      maxWidth: '1400px',
      margin: '0 auto',
      backgroundColor: 'white',
      padding: '20px',
      boxSizing: 'border-box',
    },
    mainTitle: {
      fontSize: '50px',
      fontWeight: '600',
      lineHeight: '40px',
      color: '#410684',
      textAlign: 'center',
      marginBottom: '30px',
      fontFamily: 'Oswald, sans-serif',
    },
    flexContainer: {
      display: 'flex',
      gap: '40px',
      alignItems: 'flex-start',
    },
    imageContainer: {
      flex: '0 0 45%',
      maxWidth: '500px',
    },
    image: {
      width: '85%',
      height: '265px',
      marginLeft: '130px',
      borderRadius: '10px',
      objectFit: 'cover',
      objectPosition: 'bottom',
    },
    faqSection: {
      flex: '1',
      maxWidth: '600px',
      marginLeft: '50px',
    },
    faqItem: {
      marginBottom: '12px',
      backgroundColor: 'white',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.15)',
    },
    question: {
      padding: '16px 20px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      cursor: 'pointer',
      fontWeight: '400',
      color: '#414042',
      backgroundColor: 'white',
      fontFamily: 'Inter, sans-serif',
    },
    iconContainer: {
      width: '24px',
      height: '24px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    iconActive: {
      transform: 'rotate(-180deg)',
    },
    answer: {
      padding: '0',
      maxHeight: '0',
      overflow: 'hidden',
      display: 'none',
    },
    answerActive: {
      padding: '0 20px 16px',
      maxHeight: 'none',
      display: 'block',
    },
    list: {
      listStyle: 'none',
      padding: '0',
      margin: '0',
    },
    listItem: {
      padding: '8px 0',
      color: '#4a5568',
      fontSize: '14px',
      lineHeight: '1.6',
      borderBottom: '1px solid #edf2f7',
    },
  };

  return (
    <div style={styles.mainContainer} className="main-container">
      <h2 
        style={styles.mainTitle} 
        className="main-title"
      >
        MANAGED IT AND SOLUTIONS
      </h2>
      
      <div style={styles.flexContainer} className="flex-container">
        <div 
          style={styles.imageContainer} 
          className="image-container"
        >
          <img 
            src="/managedit1.jpg"
            alt="IT Services Team"
            style={styles.image}
            className="image"
          />
        </div>
        
        <div 
          style={styles.faqSection} 
          className="faq-section"
        >
          {faqData.map((item, index) => (
            <div key={index} style={styles.faqItem}>
              <div 
                style={styles.question}
                className="question"
                onClick={() => toggleAccordion(index)}
              >
                {item.title}
                <div 
                  style={{
                    ...styles.iconContainer,
                    ...(activeIndex === index ? styles.iconActive : {})
                  }}
                >
                  <img 
                    src="/down.png" 
                    alt="icon" 
                    style={{ width: '24px', height: '24px' }} 
                  />
                </div>
              </div>
              <div 
                style={{
                  ...styles.answer,
                  ...(activeIndex === index ? styles.answerActive : {})
                }}
                className={activeIndex === index ? "answer-active" : ""}
              >
                <ul style={styles.list}>
                  {item.content.map((point, i) => (
                    <li 
                      key={i} 
                      style={{
                        ...styles.listItem,
                        borderBottom: i === item.content.length - 1 ? 'none' : '1px solid #edf2f7'
                      }}
                      className="list-item"
                    >
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;